/**
 * Golf Tournament List Reducers
 */
import {
    TOURNAMENTPROCESS_ACTION,
    ALL_TOURNAMENTPROCESS,
    ADD_TOURNAMENTPROCESS,
    EDIT_TOURNAMENTPROCESS,
    FETCH_TOURNAMENTPROCESS,
    DELETE_TOURNAMENTPROCESS,
    FETCH_TOURNAMENTPROCESSREPORT
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    tournamentprocesslist:[],
    tournamentprocessdetails:[],
    tournamentprocessreport:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case TOURNAMENTPROCESS_ACTION:
            return { ...state, loading: true };       

        case ALL_TOURNAMENTPROCESS:
            return { ...state, loading: false, tournamentprocesslist: action.payload };     
            
        case ADD_TOURNAMENTPROCESS:
            return { ...state, loading: false };    

        case EDIT_TOURNAMENTPROCESS:
            return { ...state, loading: false }; 

        case FETCH_TOURNAMENTPROCESS:
            return { ...state, loading: false, tournamentprocessdetails: action.payload };  
            
        case DELETE_TOURNAMENTPROCESS:
            return { ...state, loading: false };  
            
        case FETCH_TOURNAMENTPROCESSREPORT:
            return { ...state, loading: false, tournamentprocessreport: action.payload };
        
        default: return { ...state };

     }
 }